import { Controller } from "@hotwired/stimulus"

import DateRangePicker from 'vanillajs-datepicker/DateRangePicker';
import Datepicker from 'vanillajs-datepicker/Datepicker';
// locales
import it from 'vanillajs-datepicker/locales/it';
/* add more if needed */

Object.assign(Datepicker.locales, it);

// Connects to data-controller="datepicker"
export default class extends Controller {
  defaultLang = 'it';
  locale = this.element.dataset.locale || this.defaultLang;

  connect() {
    const dpEl = this.element;
    const options = {
      todayHighlight: true,
      autohide: true,
      clearBtn: true,
      weekStart: 1,
      todayButton: true,
      prevArrow: '<i class="mdi mdi-chevron-left"></i>',
      nextArrow: '<i class="mdi mdi-chevron-right"></i>',
      format: 'dd/mm/yyyy',
      language: this.locale
    }

    // if(dpEl.dataset.picker_type=='range'){
    //   const picker = new DateRangePicker(dpEl, options); 
    // }else{
    const picker = new Datepicker(dpEl, options);
    // }
  }
}